import { useFela } from 'react-fela';

import { config } from '@/config/config';
import { env } from '@/env';

import * as felaRules from './Logo.rules';

export interface LogoProps {
    customStyle?: typeof felaRules.container;
}

export const Logo = ({ customStyle }: LogoProps) => {
    const { css } = useFela();

    if (config.demo.enable) {
        return (
            <a className={`Logo ${css(felaRules.demoContainer, customStyle)}`} href='https://passwd.team' target='_blank' rel='noopener'>
                <img alt='Passwd logo' className={css(felaRules.image)} src={`/images/logo.svg`} />
            </a>
        );
    }
    return (
        <div className={`Logo ${css(felaRules.container, customStyle)}`}>
            <img crossOrigin='anonymous' alt='Passwd logo' className={css(felaRules.image)} src={env.VITE_LOGO_URL || `/images/logo.svg`} />
        </div>
    );
};
